import { Box } from "@mui/material";
import { useHomeData } from "../../context/HomeDataContext";

export default function Marquee() {
  const { homeData, loading } = useHomeData();

  const tollFree = homeData?.tollfreenumber || "1800 2000 2600";

  return (
    <Box
      sx={{
        width: "100%",
        overflow: "hidden",
        backgroundColor: "#fd0000",
        color: "#fff",
        paddingY: "12px",
        fontSize: { xs: "16px", sm: "18px", md: "20px" },
        fontWeight: 400,
      }}
    >
      <Box
        sx={{
          display: "flex",
          width: "max-content",
          animation: "marquee 20s linear infinite",
          "@keyframes marquee": {
            "0%": { transform: "translateX(100vw)" },
            "100%": { transform: "translateX(-100%)" },
          },
          "&:hover": {
            animationPlayState: "paused",
            cursor: "pointer",
          },
        }}
      >
        {/* Content */}
        <Box sx={{ whiteSpace: "nowrap", pr: 4 ,fontWeight:800}}>
          {loading
            ? "Loading..."
            : `Toll Free Number : ${tollFree}`}
        </Box>
      </Box>
    </Box>
  );
}
